<script>
/**
 * Tickets Data component
 */
import moment from "moment";
import EditTicket from "./update-ticket";
import TicketInfos from "./ticket-infos";
import { authComputed, ticketsMethods, devicesMethods, devicesComputed, } from "@/state/helpers";
export default {
  props: ["tickets", "ticketCauses", "busy", "loaderStatus"],
  components: {
    EditTicket,
    TicketInfos,
  },
  data() {
    return {
      ticket: null,
      ticketsList: [],
      deviceData: null,
      dataInfos : {}
    };
  },
  computed: {
    ...authComputed,
    ...devicesComputed,
    fieldsComputed() {
      if (this.loggedIn.user.role != 'USER' && this.loggedIn.user.role != 'OPERATOR') {
        return [
          { key: "date", sortable: false, label: this.$t("dataTable.date.text"), class: "tdClass" },
          { key: "ref", sortable: false, label: "ref", class: "tdClass" },
          { key: "serial", sortable: false, label: "Serial", class: "tdClass" },
          { key: "region", sortable: false, label: this.$t("dataTable.region.text"), class: "tdClass" },
          { key: "province", sortable: false, label: this.$t("dataTable.province.text"), class: "tdClass" },
          { key: "centre", sortable: false, label: this.$t("dataTable.centre.text"), class: "tdClass" },
          { key: "causes", sortable: false, label: this.$t("dataTable.causes.text"), class: "tdClass" },
          { key: "closedAt", sortable: false, label: this.$t("dataTable.closedAt.text"), class: "tdClass" },
          { key: "note", sortable: false, label: this.$t("dataTable.note.text"), class: "tdClass" },
          { key: "status", sortable: false, label: this.$t("dataTable.status.text"), class: "tdClass" },
          { key: "actions", sortable: false, label: this.$t("dataTable.tools.text"), class: "tdClass" },
        ];
      } else {
        return [
          { key: "date", sortable: false, label: this.$t("dataTable.date.text"), class: "tdClass" },
          { key: "ref", sortable: false, label: "ref", class: "tdClass" },
          { key: "serial", sortable: false, label: "serial", class: "tdClass" },
          { key: "region", sortable: false, label: this.$t("dataTable.region.text"), class: "tdClass" },
          { key: "province", sortable: false, label: this.$t("dataTable.province.text"), class: "tdClass" },
          { key: "centre", sortable: false, label: this.$t("dataTable.centre.text"), class: "tdClass" },
          { key: "causes", sortable: false, label: this.$t("dataTable.causes.text"), class: "tdClass" },
          { key: "closedAt", sortable: false, label: this.$t("dataTable.closedAt.text"), class: "tdClass" },
          { key: "note", sortable: false, label: this.$t("dataTable.note.text"), class: "tdClass" },
          { key: "status", sortable: false, label: this.$t("dataTable.status.text"), class: "tdClass" },
        ];
      }
    },
  },
  mounted() {},
  methods: {
    ...ticketsMethods,
    ...devicesMethods,
    retrieveTicket(id){
      return this.getTicketInfos(id)
        .then((ticket) => {
          return ticket;
        })
        .catch((error) => {
          return error;
        });
    },
    retrieveDevice(serial){
      return this.getDeviceInfosBySerial(serial)
        .then((device) => {
          return device;
        })
        .catch((error) => {
          return error;
        });
    },
    retrieveEvents({ serial, from, to }) {
      let params = {
        serial: serial,
        sortBy: "createdAt:desc",
      };
      if (from && to) {
        params = {
          ...params,
          limit: 100000,
          from: from,
          to: to,
        };
      }
      return this.getEventsBy(params)
        .then((events) => {
          return events.results;
        })
        .catch((error) => {
          return error;
        });
    },
    showModalEdit() {
      this.$bvModal.show("edit-ticket-modal");
    },
    showModalInfos() {
      this.$bvModal.show("ticket-infos-modal");
    },
    hideModalEdit() {
      this.$bvModal.hide("edit-ticket-modal");
    },
    cloture(ticket) {
      this.updateTicket(ticket)
        .then(() => {
          this.makeToast(
            "Update ticket",
            "ticket has been updated",
            "success"
          );
        })
        .catch((error) => {
          this.makeToast("Update ticket", error, "danger");
        });
    },
    passTicket(type, ticket) {
      if (type == "edit") {
        this.ticket = ticket;
        this.showModalEdit();
      } else if (type == "delete") {
        this.$swal
          .fire({
            title: this.$t('modals.askValidDelete.text'),
            text: this.$t('modals.cantRevert.text'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("buttons.validDelete.text"),
            cancelButtonText: this.$t("buttons.cancel.text"),
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.delTicket(ticket.id)
                .then((response) => {
                  return response;
                })
                .catch((error) => {
                  this.$swal.showValidationMessage(`Request failed: ${error}`);
                });
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal.fire(
                "Deleted!",
                "The ticket has been deleted.",
                "success"
              );
            }
          })
          .catch((error) => {
            this.makeToast("Alert Error", error, "danger");
          });
      }
    },
    makeToast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    async rowClicked(record) {
      this.ticket = await this.retrieveTicket(record.id)
      const ticketD = {...this.ticket}
      ticketD.date = record.date
      ticketD.closedAt = record.closedAt
      ticketD.actions = record.actions
      ticketD.causes = record.causes
      ticketD.createdBy = record.createdBy
      ticketD.closedBy = record.closedBy
      ticketD.technicien = record.technicien
      this.deviceData = await this.retrieveDevice(record.serial)
      this.showModalInfos()
      const from = moment(record.date, "DD-MM-YYYY HH:mm:ss").subtract(2, 'hours')
      const to = moment(record.date, "DD-MM-YYYY HH:mm:ss").add(2, 'hours')
      this.tempData = await this.retrieveEvents({
        serial: record.serial,
        from,
        to
      })
      this.dataInfos = {
        ticket: ticketD,
        deviceData: this.deviceData,
        tempData: this.tempData
      }
    },
  },
  watch: {
    tickets(newVal) {
      this.ticketsList = []
      newVal.forEach(obj=>{
        const causesNames = obj.causes?.map(c=>c.name)
        const actionsNames = obj.actions?.map(a=>a.name)
        this.ticketsList.push({
          ...obj,
          id: obj.id,
          ref: obj.ref || '-',
          serial: obj.serial,
          region: obj.region.name,
          province: obj.province.name,
          centre: obj.centre?.name || '-',
          causes: causesNames.length > 0 ? causesNames.join(',') : '-',
          actions: actionsNames.length > 0 ? actionsNames.join(',') : '-',
          status: obj.status,
          note: obj.note,
          closedAt: obj.closedAt ? moment(obj.closedAt).format("DD-MM-YYYY HH:mm:ss") : '-',
          date: moment(obj.createdAt).format("DD-MM-YYYY HH:mm:ss"),
          createdBy: obj.createdBy?.fullName || '-',
          closedBy: obj.closedBy?.fullName || '-',
          technicien: obj.technicien?.fullName || '-',
        })
      })
    },
  },
};
</script>

<template>
  <div>
    <div
      class="table-responsive mb-3 bg-white rounded-lg"
      style="min-height: 350px"
    >
      <b-table
        class="mb-0"
        hover
        show-empty
        centred
        :busy="busy"
        :empty-text="$t('dataTable.noTickets.text')"
        :items="ticketsList"
        :fields="fieldsComputed"
        v-bind:style="{ cursor: `pointer` }"
        stacked="sm"
        @row-clicked="rowClicked"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <strong>{{$t('dataTable.loading.text')}}</strong>
          </div>
        </template>
        <template v-slot:cell(date)="row">
          <div>
            <strong>{{row.item.date}}</strong>
          </div>
        </template>
        <template v-slot:cell(status)="row">
          <div
            class="badge font-size-12 text-center"
            :class="{
              'badge-soft-warning': `${row.item.status}` === 'OPENED',
              'badge-soft-secondary': `${row.item.status}` === 'SUSPENDED',
              'badge-soft-success': `${row.item.status}` === 'CLOSED',
            }"
          >
            {{ row.item.status }}
          </div>
        </template>
        <template v-slot:cell(actions)="data">
          <div class="d-inline-flex align-items-center" v-if="data.item.status == 'OPENED'">
            <b-button
              type="button"
              class="mr-2"
              variant="light"
              @click="passTicket('edit', data.item)"
              >{{$t("buttons.cloture.text")}}
            </b-button>
          </div>
        </template>
      </b-table>
      <EditTicket v-bind:ticket="ticket" @clotureTicket="cloture" :ticketCauses="ticketCauses" />
      <TicketInfos v-bind:data="dataInfos" />
    </div>
  </div>
</template>
<style>
.tdClass {
  text-align: center;
}
</style>